import { Button, Center, Stack, Text, useMediaQuery } from '@chakra-ui/react';
import { Modal } from '@diamond/shared/ui';
import React from 'react';

interface ModalNotificationProps {
  isOpen: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  message?: React.ReactNode;
  primaryLabel?: string;
  onPrimary?: () => void;
  secondaryLabel?: string;
  onSecondary?: () => void;
  name?: string;
  size?:
    | 'xs'
    | 'sm'
    | 'md'
    | 'lg'
    | 'xl'
    | '2xl'
    | '3xl'
    | '4xl'
    | '5xl'
    | '6xl'
    | 'full';
  stickyToBottom?: boolean;
  hideClose?: boolean;
}

export const ModalNotification: React.FC<ModalNotificationProps> = ({
  isOpen,
  onClose,
  title,
  message,
  name,
  primaryLabel = 'Lanjutkan',
  onPrimary,
  secondaryLabel = 'Lihat Keranjang',
  onSecondary,
  size = 'md',
  stickyToBottom = false,
  hideClose = false,
}) => {
  const [isMobile] = useMediaQuery('(max-width: 768px)');
  const modalName = name || 'modal-notification';

  const handlePrimary = () => {
    if (onPrimary) onPrimary();
    else onClose();
  };

  const handleSecondary = () => {
    if (onSecondary) onSecondary();
    else onClose();
  };

  return (
    <Modal
      name={modalName}
      isOpen={isOpen}
      onClose={onClose}
      size={size}
      isCentered
      hideAction
      stickyToBottom={stickyToBottom}
      hideClose={hideClose}
    >
      <Center p={6}>
        <Text
          fontSize={{ base: 'xl', md: '2xl' }}
          fontWeight="bold"
          textAlign="center"
          m={4}
        >
          {title}
        </Text>
      </Center>
      {message && (
        <Center mb={6}>
          <Text textAlign="center">{message}</Text>
        </Center>
      )}

      <Stack
        direction={isMobile ? 'column' : 'row'}
        spacing={4}
        justifyContent="center"
        mb={4}
      >
        <Button
          variant="outline"
          onClick={handleSecondary}
          w={{ base: 'full', md: '40' }}
        >
          {secondaryLabel}
        </Button>
        <Button
          variant="solid"
          onClick={handlePrimary}
          w={{ base: 'full', md: '40' }}
        >
          {primaryLabel}
        </Button>
      </Stack>
    </Modal>
  );
};

export default ModalNotification;
